import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const WeekNavigator = ({ selectedWeek, onWeekChange, onTodayClick }) => {
  const getCurrentWeekStart = () => {
    const today = new Date();
    const dayOfWeek = today?.getDay();
    const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
    const monday = new Date(today);
    monday?.setDate(today?.getDate() + mondayOffset);
    monday?.setHours(0, 0, 0, 0);
    return monday;
  };

  const formatWeekRange = (weekStart) => {
    const start = new Date(weekStart);
    const end = new Date(weekStart);
    end?.setDate(end?.getDate() + 6);
    
    const startStr = start?.toLocaleDateString('de-DE', { 
      day: '2-digit', 
      month: '2-digit' 
    });
    const endStr = end?.toLocaleDateString('de-DE', { 
      day: '2-digit', 
      month: '2-digit',
      year: 'numeric'
    });
    
    return `${startStr} - ${endStr}`;
  };

  const navigateWeek = (direction) => {
    const newWeek = new Date(selectedWeek);
    newWeek?.setDate(newWeek?.getDate() + (direction * 7));
    onWeekChange(newWeek);
  };

  const isCurrentWeek = () => {
    const currentWeekStart = getCurrentWeekStart();
    return selectedWeek?.getTime() === currentWeekStart?.getTime();
  };

  const getWeekNumber = (date) => {
    const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
    const pastDaysOfYear = (date - firstDayOfYear) / 86400000;
    return Math.ceil((pastDaysOfYear + firstDayOfYear?.getDay() + 1) / 7);
  };

  return (
    <div className="flex items-center justify-between bg-card rounded-lg border border-border shadow-card p-4 mb-6">
      <div className="flex items-center space-x-4">
        <Button
          variant="outline"
          size="sm"
          iconName="ChevronLeft"
          iconSize={16}
          onClick={() => navigateWeek(-1)}
          className="px-3"
        />
        
        <div className="text-center">
          <h2 className="text-lg font-semibold text-foreground">
            {formatWeekRange(selectedWeek)}
          </h2>
          <p className="text-sm text-muted-foreground">
            KW {getWeekNumber(selectedWeek)} • {selectedWeek?.getFullYear()}
          </p>
        </div>
        
        <Button
          variant="outline"
          size="sm"
          iconName="ChevronRight"
          iconSize={16}
          onClick={() => navigateWeek(1)}
          className="px-3"
        />
      </div>
      <div className="flex items-center space-x-2">
        {!isCurrentWeek() && (
          <Button
            variant="ghost"
            size="sm"
            iconName="Calendar"
            iconPosition="left"
            iconSize={16}
            onClick={onTodayClick}
          >
            Aktuelle Woche
          </Button>
        )}
        
        <div className="flex items-center space-x-1 text-sm text-muted-foreground">
          <Icon name="Info" size={14} />
          <span>Klicken & Ziehen zum Auswählen</span>
        </div>
      </div>
    </div>
  );
};

export default WeekNavigator;